// project-imports
import { deleteRequest, getRequest, postRequest, putRequest } from 'utils/action-manager/actionManager';
import { APIAction } from '../apiManager';

// ==============================|| API MANAGER - DT REQUESTS ||============================== //

export async function handleDTRequests(action: APIAction) {
  switch (action.method) {
    case 'create':
      return postRequest('/dt-requests', action.data);
    case 'read':
      return getRequest(`/dt-requests?agent-id=${action.id}`);
    case 'update':
      return putRequest(`/dt-requests/${action.id}`, action.data);
    case 'delete':
      return deleteRequest(`/dt-requests/${action.id}`);
    default:
      console.info('[ApiManager > handleApiAction > handleDTRequests] - Unknown method');
      break;
  }
}
